"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOCXAnyELs = exports.DOCXAnyELsToBlocks = exports.HTMLAnyELs = exports.HTMLAnyELsToBlocks = exports.HTMLAnyELsCSS = void 0;
const react_1 = __importDefault(require("react"));
const std = __importStar(require("../../law/std"));
const inline_1 = require("../../node/cst/inline");
const util_1 = require("../../util");
const amendProvision_1 = require("./amendProvision");
const appdxItem_1 = require("./appdxItem");
const article_1 = require("./article");
const articleGroup_1 = require("./articleGroup");
const columnsOrSentencesRun_1 = require("./columnsOrSentencesRun");
const component_1 = require("../common/docx/component");
const tags_1 = require("../common/docx/tags");
const figRun_1 = require("./figRun");
const html_1 = require("../common/html");
const itemStruct_1 = require("./itemStruct");
const law_1 = require("./law");
const list_1 = require("./list");
const noteLike_1 = require("./noteLike");
const paragraphItem_1 = require("./paragraphItem");
const remarks_1 = require("./remarks");
const sentenceChildrenRun_1 = require("./sentenceChildrenRun");
const supplNote_1 = require("./supplNote");
const table_1 = require("./table");
const toc_1 = require("./toc");
const common_1 = require("../common");
exports.HTMLAnyELsCSS = `

`;
const HTMLAnyELsToBlocks = (props) => {
    const { els, htmlOptions, indent } = props;
    const blocks = [];
    let currentRuns = [];
    const flushRuns = () => {
        if (currentRuns.length > 0) {
            blocks.push(currentRuns);
            currentRuns = [];
        }
    };
    for (let i = 0; i < els.length; i++) {
        const el = els[i];
        if (std.isLaw(el)) {
            flushRuns();
            blocks.push(react_1.default.createElement(law_1.HTMLLaw, { el: el, indent: indent, htmlOptions }));
        }
        else if (std.isArticleGroup(el) || std.isMainProvision(el) || std.isSupplProvision(el)) {
            flushRuns();
            blocks.push(react_1.default.createElement(articleGroup_1.HTMLArticleGroup, { el: el, indent: indent, htmlOptions }));
        }
        else if (std.isArticle(el)) {
            flushRuns();
            blocks.push(react_1.default.createElement(article_1.HTMLArticle, { el: el, indent: indent, htmlOptions }));
        }
        else if (std.isParagraphItem(el)) {
            flushRuns();
            blocks.push(react_1.default.createElement(paragraphItem_1.HTMLParagraphItem, { el: el, indent: indent, htmlOptions }));
        }
        else if (std.isTable(el)) {
            flushRuns();
            blocks.push(react_1.default.createElement(table_1.HTMLTable, { el: el, indent: indent, htmlOptions }));
        }
        else if (std.isTableStruct(el) || std.isFigStruct(el) || std.isNoteLikeStruct(el)) {
            flushRuns();
            blocks.push(react_1.default.createElement(itemStruct_1.HTMLItemStruct, { el: el, indent: indent, htmlOptions }));
        }
        else if (std.isAppdxItem(el)) {
            flushRuns();
            blocks.push(react_1.default.createElement(appdxItem_1.HTMLAppdxItem, { el: el, indent: indent, htmlOptions }));
        }
        else if (std.isRemarks(el)) {
            flushRuns();
            blocks.push(react_1.default.createElement(remarks_1.HTMLRemarks, { el: el, indent: indent, htmlOptions }));
        }
        else if (std.isNoteLike(el)) {
            flushRuns();
            blocks.push(react_1.default.createElement(noteLike_1.HTMLNoteLike, { el: el, indent: indent, htmlOptions }));
        }
        else if (std.isList(el)) {
            flushRuns();
            blocks.push(react_1.default.createElement(list_1.HTMLList, { el: el, indent: indent, htmlOptions }));
        }
        else if (std.isAmendProvision(el)) {
            flushRuns();
            blocks.push(react_1.default.createElement(amendProvision_1.HTMLAmendProvision, { el: el, indent: indent, htmlOptions }));
        }
        else if (std.isSupplNote(el)) {
            flushRuns();
            blocks.push(react_1.default.createElement(supplNote_1.HTMLSupplNote, { el: el, indent: indent, htmlOptions }));
        }
        else if (std.isEnactStatement(el)) {
            flushRuns();
            blocks.push(react_1.default.createElement(law_1.HTMLEnactStatement, { el: el, indent: indent, htmlOptions }));
        }
        else if (std.isPreamble(el)) {
            flushRuns();
            blocks.push(react_1.default.createElement(law_1.HTMLPreamble, { el: el, indent: indent, htmlOptions }));
        }
        else if (std.isTOC(el)) {
            flushRuns();
            blocks.push(react_1.default.createElement(toc_1.HTMLTOC, { el: el, indent: indent, htmlOptions }));
        }
        else if (std.isTOCItem(el)) {
            flushRuns();
            blocks.push(react_1.default.createElement(toc_1.HTMLTOCItem, { el: el, indent: indent, htmlOptions }));
        }
        else if (std.isArticleGroupTitle(el) || std.isLawTitle(el)) {
            flushRuns();
            blocks.push((react_1.default.createElement("div", { className: `any-els-tag any-els-tag-${el.tag} indent-${indent}` },
                react_1.default.createElement(sentenceChildrenRun_1.HTMLSentenceChildrenRun, { els: el.children, htmlOptions }))));
        }
        else if (std.isSentence(el)) {
            let j = i + 1;
            while (j < els.length && std.isSentence(els[j]))
                j++;
            const sentences = els.slice(i, j);
            currentRuns.push(react_1.default.createElement(columnsOrSentencesRun_1.HTMLColumnsOrSentencesRun, { els: sentences, htmlOptions }));
            i = j - 1;
        }
        else if (std.isColumn(el)) {
            let j = i + 1;
            while (j < els.length && std.isColumn(els[j]))
                j++;
            const columns = els.slice(i, j);
            currentRuns.push(react_1.default.createElement(columnsOrSentencesRun_1.HTMLColumnsOrSentencesRun, { els: columns, htmlOptions }));
            i = j - 1;
        }
        else if (typeof el === "string" || (0, inline_1.isSentenceChildEL)(el)) {
            // "Line", "QuoteStruct", "ArithFormula", "Ruby", "Sup", "Sub"
            let j = i + 1;
            while (j < els.length && (typeof els[j] === "string" || (0, inline_1.isSentenceChildEL)(els[j])))
                j++;
            const sentenceChildren = els.slice(i, j);
            currentRuns.push(react_1.default.createElement(sentenceChildrenRun_1.HTMLSentenceChildrenRun, { els: sentenceChildren, htmlOptions }));
            i = j - 1;
        }
        else if (std.isFig(el)) {
            currentRuns.push(react_1.default.createElement(figRun_1.HTMLFigRun, { el: el, htmlOptions }));
        }
        else {
            throw new util_1.NotImplementedError(el.tag);
        }
    }
    flushRuns();
    return blocks;
};
exports.HTMLAnyELsToBlocks = HTMLAnyELsToBlocks;
exports.HTMLAnyELs = (0, html_1.wrapHTMLComponent)("HTMLAnyELs", ((props) => {
    const { indent } = props;
    const rawBlocks = (0, exports.HTMLAnyELsToBlocks)(props);
    const blocks = [];
    for (const rawBlock of rawBlocks) {
        if (Array.isArray(rawBlock)) {
            blocks.push((react_1.default.createElement("div", { className: `any-els-runs indent-${indent}` }, (0, common_1.withKey)(rawBlock))));
        }
        else {
            blocks.push(rawBlock);
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, (0, common_1.withKey)(blocks)));
}));
const DOCXAnyELsToBlocks = (props) => {
    const { els, docxOptions, indent } = props;
    const blocks = [];
    let currentRuns = [];
    const flushRuns = () => {
        if (currentRuns.length > 0) {
            blocks.push(currentRuns);
            currentRuns = [];
        }
    };
    for (let i = 0; i < els.length; i++) {
        const el = els[i];
        if (std.isLaw(el)) {
            flushRuns();
            blocks.push(react_1.default.createElement(law_1.DOCXLaw, { el: el, indent: indent, docxOptions }));
        }
        else if (std.isArticleGroup(el) || std.isMainProvision(el) || std.isSupplProvision(el)) {
            flushRuns();
            blocks.push(react_1.default.createElement(articleGroup_1.DOCXArticleGroup, { el: el, indent: indent, docxOptions }));
        }
        else if (std.isArticle(el)) {
            flushRuns();
            blocks.push(react_1.default.createElement(article_1.DOCXArticle, { el: el, indent: indent, docxOptions }));
        }
        else if (std.isParagraphItem(el)) {
            flushRuns();
            blocks.push(react_1.default.createElement(paragraphItem_1.DOCXParagraphItem, { el: el, indent: indent, docxOptions }));
        }
        else if (std.isTable(el)) {
            flushRuns();
            blocks.push(react_1.default.createElement(table_1.DOCXTable, { el: el, indent: indent, docxOptions }));
        }
        else if (std.isTableStruct(el) || std.isFigStruct(el) || std.isNoteLikeStruct(el)) {
            flushRuns();
            blocks.push(react_1.default.createElement(itemStruct_1.DOCXItemStruct, { el: el, indent: indent, docxOptions }));
        }
        else if (std.isAppdxItem(el)) {
            flushRuns();
            blocks.push(react_1.default.createElement(appdxItem_1.DOCXAppdxItem, { el: el, indent: indent, docxOptions }));
        }
        else if (std.isRemarks(el)) {
            flushRuns();
            blocks.push(react_1.default.createElement(remarks_1.DOCXRemarks, { el: el, indent: indent, docxOptions }));
        }
        else if (std.isNoteLike(el)) {
            flushRuns();
            blocks.push(react_1.default.createElement(noteLike_1.DOCXNoteLike, { el: el, indent: indent, docxOptions }));
        }
        else if (std.isList(el)) {
            flushRuns();
            blocks.push(react_1.default.createElement(list_1.DOCXList, { el: el, indent: indent, docxOptions }));
        }
        else if (std.isAmendProvision(el)) {
            flushRuns();
            blocks.push(react_1.default.createElement(amendProvision_1.DOCXAmendProvision, { el: el, indent: indent, docxOptions }));
        }
        else if (std.isSupplNote(el)) {
            flushRuns();
            blocks.push(react_1.default.createElement(supplNote_1.DOCXSupplNote, { el: el, indent: indent, docxOptions }));
        }
        else if (std.isEnactStatement(el)) {
            flushRuns();
            blocks.push(react_1.default.createElement(law_1.DOCXEnactStatement, { el: el, indent: indent, docxOptions }));
        }
        else if (std.isPreamble(el)) {
            flushRuns();
            blocks.push(react_1.default.createElement(law_1.DOCXPreamble, { el: el, indent: indent, docxOptions }));
        }
        else if (std.isTOC(el)) {
            flushRuns();
            blocks.push(react_1.default.createElement(toc_1.DOCXTOC, { el: el, indent: indent, docxOptions }));
        }
        else if (std.isTOCItem(el)) {
            flushRuns();
            blocks.push(react_1.default.createElement(toc_1.DOCXTOCItem, { el: el, indent: indent, docxOptions }));
        }
        else if (std.isArticleGroupTitle(el) || std.isLawTitle(el)) {
            flushRuns();
            blocks.push((react_1.default.createElement(tags_1.w.p, null,
                react_1.default.createElement(tags_1.w.pPr, null,
                    react_1.default.createElement(tags_1.w.pStyle, { "w:val": `Indent${indent}` })),
                react_1.default.createElement(sentenceChildrenRun_1.DOCXSentenceChildrenRun, { els: el.children, emphasis: true, docxOptions }))));
        }
        else if (std.isSentence(el)) {
            let j = i + 1;
            while (j < els.length && std.isSentence(els[j]))
                j++;
            const sentences = els.slice(i, j);
            currentRuns.push(react_1.default.createElement(columnsOrSentencesRun_1.DOCXColumnsOrSentencesRun, { els: sentences, docxOptions }));
            i = j - 1;
        }
        else if (std.isColumn(el)) {
            let j = i + 1;
            while (j < els.length && std.isColumn(els[j]))
                j++;
            const columns = els.slice(i, j);
            currentRuns.push(react_1.default.createElement(columnsOrSentencesRun_1.DOCXColumnsOrSentencesRun, { els: columns, docxOptions }));
            i = j - 1;
        }
        else if (typeof el === "string" || (0, inline_1.isSentenceChildEL)(el)) {
            // "Line", "QuoteStruct", "ArithFormula", "Ruby", "Sup", "Sub"
            let j = i + 1;
            while (j < els.length && (typeof els[j] === "string" || (0, inline_1.isSentenceChildEL)(els[j])))
                j++;
            const sentenceChildren = els.slice(i, j);
            currentRuns.push(react_1.default.createElement(sentenceChildrenRun_1.DOCXSentenceChildrenRun, { els: sentenceChildren, docxOptions }));
            i = j - 1;
        }
        else if (std.isFig(el)) {
            currentRuns.push(react_1.default.createElement(figRun_1.DOCXFigRun, { el: el, docxOptions }));
        }
        else {
            throw new util_1.NotImplementedError(el.tag);
        }
    }
    flushRuns();
    return blocks;
};
exports.DOCXAnyELsToBlocks = DOCXAnyELsToBlocks;
exports.DOCXAnyELs = (0, component_1.wrapDOCXComponent)("DOCXAnyELs", ((props) => {
    const { indent } = props;
    const rawBlocks = (0, exports.DOCXAnyELsToBlocks)(props);
    const blocks = [];
    for (const rawBlock of rawBlocks) {
        if (Array.isArray(rawBlock)) {
            blocks.push((react_1.default.createElement(tags_1.w.p, null,
                react_1.default.createElement(tags_1.w.pPr, null,
                    react_1.default.createElement(tags_1.w.pStyle, { "w:val": `Indent${indent}` })),
                (0, common_1.withKey)(rawBlock))));
        }
        else {
            blocks.push(rawBlock);
        }
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, (0, common_1.withKey)(blocks)));
}));
//# sourceMappingURL=any.js.map